module.exports = __webpack_public_path__ + "media/components/molecules/misc/drag_indicator-24px-b821668f4d58d58b1be0729fab184db6.svg";